// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"f5aa3936","426":"0a4ada7c"}[chunkId] + ".chunk.css";
};